import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import { t } from '../../../../modules/infra/i18n';

import withPermissions from '../../../auth/utils/withPermissions';
import { barberCreate, barberFetch, barberUpdate, shopCreate, shopFetch, shopUpdate } from './actions';
import { getShop } from '../../../auth/selectors';
import { getWaitingList } from './selectors';
import { syncValidateData } from '../../../common/validator';
import WaitingList from './WaitingList';
import fetchOnUpdate from '../../../common/decorators/fetchOnUpdate';
import withNotifications from '../../../common/withNotifications';

const schema = {
  WaitingListThreshold: Joi.number().min(1).max(24).required(),
  enabled: Joi.boolean().optional(),
};

const WAITING_LIST_FORM = 'waitingListFrom';

const form = reduxForm({
  form: WAITING_LIST_FORM,
  enableReinitialize: true,
  validate: (values) => syncValidateData(values, schema),
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.addNotification({
      title: t('settings:waiting_list.success_title'),
      level: 'success',
      message: t('settings:waiting_list.changes_saved_successfully'),
    });
  },
});

const addCreateAndUpdateHanders = withHandlers({
  update: (props) => (data) => {
    if (props.barberUser) {
      return props.barberUpdate(props.barberUser.id, data);
    }

    return props.shopUpdate(props.shop, data);
  },
  create: (props) => (data) => {
    if (props.barberUser) {
      return props.barberCreate(props.barberUser.id, data);
    }

    return props.shopCreate(props.shop, data);
  },
});

const addHandlers = withHandlers({
  onSubmit: (props) => (data) => {
    if (data.id) {
      return props.update(data);
    }

    return props.create(data);
  },
});

const prepareFetchParams = withProps((props) => ({
  params: {
    shop: props.shop,
    barberUser: props.barberUser,
  },
  actions: {
    shopFetch: props.shopFetch,
    barberFetch: props.barberFetch,
  },
}));

const fetch = fetchOnUpdate(['shop', 'barberUser'], (params, actions) => {
  if (params.barberUser) {
    return actions.barberFetch(params.barberUser.id);
  }
  return actions.shopFetch(params.shop);
});

export default compose(
  withPermissions,
  connect(
    (state) => ({
      shop: getShop(state),
      barberUser: state.auth.barberUser,
      initialValues: getWaitingList(state),
    }),
    { shopCreate, shopUpdate, shopFetch, barberCreate, barberUpdate, barberFetch }
  ),
  withNotifications,
  addCreateAndUpdateHanders,
  addHandlers,
  form,
  prepareFetchParams,
  fetch
)(WaitingList);
